import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export interface CustomerData {
  name: string;
  email: string;
  phone: string;
  dni: string;
  address: string;
}

export interface PaymentRequest {
  /** Importe en euros. Ej: 25.50 */
  amount: number;
  concept: string;
  /** ID del trastero, p.ej. 'BOX001' */
  boxId: string;
  isBizum?: boolean;
  lang?: string;
  /** Datos del cliente para auditoría y recuperación de fallos */
  customer: CustomerData;
  /** Firma del cliente como imagen base64 (PNG) */
  signatureBase64: string;
}

export interface PaymentFormData {
  type: string;
  Ds_SignatureVersion: string;
  Ds_MerchantParameters: string;
  Ds_Signature: string;
  orderId: string;
  tpvUrl: string;
}

export interface LibrePaymentRequest {
  amount: number;
  concept: string;
  isBizum?: boolean;
  lang?: string;
  customer: Pick<CustomerData, 'name' | 'email' | 'phone'>;
}

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  private readonly API_URL = '/api/payment';

  constructor(private http: HttpClient) {}

  createPayment(params: PaymentRequest): Promise<PaymentFormData> {
    return firstValueFrom(
      this.http.post<PaymentFormData>(`${this.API_URL}/create`, {
        amount: params.amount.toFixed(2),
        concept: params.concept,
        boxId: params.boxId,
        isBizum: params.isBizum ?? false,
        lang: params.lang ?? 'es',
        customer: params.customer,
        signatureBase64: params.signatureBase64,
      })
    );
  }

  createLibrePayment(params: LibrePaymentRequest): Promise<PaymentFormData> {
    return firstValueFrom(
      this.http.post<PaymentFormData>(`${this.API_URL}/create-libre`, {
        amount: params.amount.toFixed(2),
        concept: params.concept,
        isBizum: params.isBizum ?? false,
        lang: params.lang ?? 'es',
        customer: params.customer,
      })
    );
  }
}
